import React, { useEffect, useState } from "react";

import { FormattedDate } from "react-intl";

import { css, useTheme } from "@emotion/react";
import styled from "@emotion/styled";

import { apiFetch } from "../../../../apiBindings";
import LinkComponent from "../../LinkComponent";
import LoadingIndicator from "../../LoadingIndicator";
import Card, { CardContainer } from "../../Menu/Card";
import DocumentsCard from "../../Menu/DocumentsCard";
import NewHeadline from "../../NewHeadline";
import HeadlineItem from "../ContentElement/HeadlineItem";

const Container = styled.div`
    ${({ theme }) => css`
        ${theme.breakpoints.from.small.css`
          ${theme.paddings.containerOuterInner.left}
          ${theme.paddings.containerOuterInner.right}
      `}
    `}
`;

const MenuContainer = styled.div`
    padding-top: 20px;
    padding-bottom: 20px;
    display: flex;
    flex-direction: column;
    row-gap: 20px;
`;

const CardWrapper = styled.div`
    display: flex;
    width: 100%;
    flex-wrap: wrap;
`;

const DocumentsContainer = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: 20px;
    align-items: center;
    justify-content: center;
`;

const LinkWrapper = styled.div`
    display: block;
    margin: 20px 0;
`;

const HoyerCampusRestaurantMenu = ({ headlineNumber, text }) => {
    const [data, setData] = useState(undefined);
    const [loading, setLoading] = useState(false);
    const theme = useTheme();

    useEffect(() => {
        setLoading(true);
        void apiFetch("/gas-stations/kkc")
            .then((response) => response.json())
            .then((response) => {
                setLoading(false);
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                setData({
                    ...response,
                    menus: response.menus.map((menu) => {
                        const meals = {};
                        menu.meals.forEach((meal) => {
                            if (!meals[meal.day]) {
                                meals[meal.day] = [];
                            }
                            meals[meal.day].push(meal);
                        });
                        return { ...menu, meals };
                    }),
                });
            });
    }, []);

    const hasDocuments = () => {
        return data !== null && data.files?.documents;
    };

    const hasAllergenes = () => {
        return data !== null && data.files?.allergenes;
    };

    const cardContainerStyles = css`
        ${theme.breakpoints.from.medium.css`
            flex-wrap: wrap
        `}
    `;

    if (loading) {
        return <LoadingIndicator />;
    }

    return data ? (
        <Container>
            <HeadlineItem headline={headlineNumber}>{text}</HeadlineItem>
            {data.menus.map((weekMenu, index) => (
                <React.Fragment key={index}>
                    <NewHeadline>{weekMenu.name}</NewHeadline>
                    <div>
                        Wochenangebot:{" "}
                        <FormattedDate value={weekMenu.from} format="short" /> -{" "}
                        <FormattedDate value={weekMenu.to} format="short" />
                    </div>
                    <MenuContainer>
                        {Object.keys(weekMenu.meals).map((weekday, index) => {
                            return (
                                <CardContainer
                                    key={index}
                                    css={cardContainerStyles}
                                >
                                    {weekMenu.meals[weekday].map(
                                        (meal, index) => (
                                            <CardWrapper key={index}>
                                                <Card
                                                    left={
                                                        index === 0
                                                            ? meal.day
                                                            : ""
                                                    }
                                                    middle={meal.parts}
                                                    right={meal.price}
                                                    container={false}
                                                />
                                            </CardWrapper>
                                        )
                                    )}
                                </CardContainer>
                            );
                        })}
                    </MenuContainer>
                </React.Fragment>
            ))}
            {(hasAllergenes() || hasDocuments()) && (
                <DocumentsContainer>
                    {hasAllergenes() && (
                        <LinkWrapper>
                            <LinkComponent
                                link={{
                                    text: "Zusatzstoffe und Allergene",
                                    href: data.files.allergenes,
                                }}
                                underline
                                anchor
                            />
                        </LinkWrapper>
                    )}
                    {hasDocuments() && (
                        <DocumentsCard document={data.documents} />
                    )}
                </DocumentsContainer>
            )}
        </Container>
    ) : null;
};

export default HoyerCampusRestaurantMenu;
